import clsx from 'clsx';
import type { ReactNode } from 'react';

import BaseContainer, { type BaseContainerProps } from '@commons/containers/BaseContainer';

import Icon from '../Icon';
import styles from './index.module.scss';

// Type definition for the Quote component props.

type Props = BaseContainerProps & {
  children: ReactNode;
  withIcon?: boolean;
};

/**
 * Quote component.
 *
 * Overrides the styles of its text children with its own CSS variables.
 */

const Quote = ({ children, withIcon = false, className, ...props }: Props) => (
  <BaseContainer className={clsx(styles.quote, className)} {...props}>
    {withIcon && <Icon type="quote" className={styles.icon} />}
    {children}
  </BaseContainer>
);

export default Quote;
